import React from "react";


// material components
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddCircleIcon from "@material-ui/icons/AddCircle";
import VisibilityIcon from '@material-ui/icons/Visibility';
import SendIcon from '@material-ui/icons/Send';
import GetAppIcon from '@material-ui/icons/GetApp';
import Paper from "@material-ui/core/Paper";

// custom components

import withShipment from "../../../withShipment";
import DateFnsUtils from '@date-io/date-fns';

// constants
import { CREATE_PURCHASE_ORDER, PURCHASE_ORDER } from "./constants";
import {DEFAULT_PDF_ZOOM} from "../../global/constants";

// redux
import {
    cachePDFpreview,
    deleteInventoryReceived,
    fetchAllPurchaseOrders,
    getPDFpreview,
    previewCreatedPurchaseOrder,
    previewPackingSlipFile,
    createSendNewPurchaseOrder,
    createNewPurchaseOrder,
    updatePurchaseOrder,
    cancelPurchaseOrder,
    editPurchaseOrder,
    undoCancelPurchaseOrder,
    resetPdfPreviewData,
    storeCreatedPurchaseOrderPreview,
    deletePackingSlip,
    updateExpectedDeliveryDate,
    listCustomers,
    createCustomerInvoice,
    deleteCustomerOrder,
    generateCompleteCustomerInvoice,
    storeCustomerPOOperationResponse, previewOrderConfirmationOrder,
} from '../../../redux/actions/customer';
import {
    allPurchaseOrdersSelector,
    completedPurchaseOrdersSelector,
    createdPurchaseOrderPreviewSelector,
    customerPOOperationResponseSelector,
    customersSelector,
    newPurchaseOrdersSelector, orderConfirmationPreviewSelector,
    partialPurchaseOrdersSelector,
    PDFpreviewReadySelector,
} from '../../../redux/selectors/customer';
import {
    saveTableSetting,
    getTableSetting
} from "../../../redux/actions/account";
import {
    tableSettingSelector
} from "../../../redux/selectors/account";

import PropTypes from "prop-types";
import CustomToolbar from "../../global/CustomToolbar";
import { FETCH_UNSHIPPED_ALERTS_TIME } from "../../alerts/constants";
import { userInfoSelector } from "../../../redux/selectors/auth";
import EditIcon from "@material-ui/icons/Edit";
import BlockIcon from "@material-ui/icons/Block";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import { statusSelector } from "../../../redux/selectors/global";
import { ERROR, SUCCESS } from "../../settings/ManageUsers/constants";

import {
    availableLocationsSelector,
    emailTemplatesSelector,
    hasPurchaseOrderEmailTemplateSelector,
} from "../../../redux/selectors/settings";
import {
    listAvailableLocations,
    fetchPurchaseOrderEmailTemplate,
    sendEmail_purchaseOrder, sendCustomerPurchaseOrderEmail, sendCustomerOrderConfirmationEmail,
} from '../../../redux/actions/settings';
import DeleteIcon from "@material-ui/icons/Delete";
import ClearIcon from "@material-ui/icons/Clear";
import UndoIcon from '@material-ui/icons/Undo';
import { GetApp} from "@material-ui/icons";
import "./PurchaseCustomerOrdersTable.css";
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import {DEFAULT_ROWS_PER_PAGE} from "../../returns/constants";
import SaveIcon from "@material-ui/icons/Save";
import DescriptionIcon from "@material-ui/icons/Description";
import PurchaseCustomerOrdersTable from "./PurchaseCustomerOrdersTable";
import CreateCustomerPurchaseOrder from "./CreateCustomerPurchaseOrder";
import PurchaseCustomerOrderDetails from "./PurchaseCustomerOrderDetails";
import EditCustomerPurchaseOrders from "./EditCustomerPurchaseOrders";
import AssignmentIcon from "@material-ui/icons/Assignment";

class PurchaseCustomerOrders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            previewPackingSlip: false,
            pdfDataSlip: [],
            create: false,
            submitting: false,
            showingCreatedPreview: false,
            showingPurchaseOrder: '',
            previewing: false,
            previewable: true,
            previewingName: "",
            pdfData: [],
            entries: this.props.user.routes.includes('po-pricing') ? [{
                shortcode: '',
                partNum: '',
                description: '',
                discount: '0.00',
                price: '',
                quantity: 0,
                deleteEntry: true
            }] : [{
                shortcode: '',
                partNum: '',
                description: '',
                discount: '0.00',
                quantity: 0,
                deleteEntry: true
            }],
            selectedCustomer: '',
            customerId: '',
            customerPurchaseOrderId: '',
            purchaseOrderEmailTemplate: null,
            notes: '',
            isSameAsBillingAddress: true,
            isHistorical: false,
            poNumber: '',
            createDate: this.currentDate(),
            expectedDate: this.initDate(),
            samePreview: false,
            editingPOqty: false,
            feedbackBarOpen: false,
            feedbackBarText: "",
            errEditQty: {},
            editingPurchaseOrder: false,
            toEditPurchaseOrder: {},
            fetchCreatedPurchaseOrderPreview: () => {
            },
            voidStatus: false,
            voidOpen: false,
            selectedLocation: {},
            toLocation: {},
            taxPercentage: "",
            discountPercentage: "0.00",
            fromDate: this.getFromDate(),
            toDate: this.getToDate(),
            isDelete: false,
            pdfLoadSuccess: true,
            canVoidPO: false,
            isCancelledPO: false,
            isUndoDelete: false,
            isCompleted: false,
            voiding: false,
            undoCancelStatus: false,
            undoCancelledFeedbackOpen: false,
            scale: DEFAULT_PDF_ZOOM,
            searchText: '',
            page: 0,
            rowsPerPage: DEFAULT_ROWS_PER_PAGE,
            previewingPS: false,
            previewingPsFile: {},
            previewingPsPoNum: 0,
            deletingPS: false,
            selectedCustomerInfo:{},
            feedbackOpen: false,
            feedback: false,
            triggerDownload: false,
            shipToAddress: {
                name: '',
                phone: '',
                country: '',
                addressLine1: '',
                addressLine2: '',
                postalCode: '',
                city:'',
                state: ''
            },
            sendPackingSlip: null,
            requiredList: [
                "customer",
                "createDate",
                "expectedDate",
                "poNumber",
                "taxPercentage",
                "selectedLocation",
                "entries"
            ],
            refetch: true,
            previewingOrderConfirmation: false,
            previewOrderPONumber: ''
        };
    }


    isPreviewEnabled = () => {
        const {
            entries,
            selectedCustomer,
            customerId,
            notes,
            isSameAsBillingAddress,
            shipToAddress,
            isHistorical,
            toLocation,
            taxPercentage,
            expectedDate,
            createDate,
            poNumber,
            requiredList
        } = this.state

        const data = {
            entries,
            customer: selectedCustomer,
            customerId,
            notes,
            isSameAsBillingAddress,
            shipToAddress,
            isHistorical,
            selectedLocation: toLocation,
            taxPercentage,
            expectedDate,
            createDate,
            poNumber
        }

        for (const field of requiredList) {
            if (!data[field] || (field === 'entries' && !Array.isArray(data.entries))) {
                return false
            }
        }

        for (const entry of entries) {
            const price = Number(entry.price)
            const quantity = Number(entry.quantity)

            if (
              !entry.shortcode ||
              entry.price === undefined || entry.price === null || price === 0 || isNaN(price) ||
              !entry.discount ||
              entry.quantity === undefined || entry.quantity === null || quantity === 0 || isNaN(quantity)
            ) {
                return false
            }
        }

        return true
    }


    handleDownloadRequest = () => {
        this.setState({ triggerDownload: true });
    }

    initDate = () => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow
    }

    currentDate = () => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate());
        return tomorrow
    }

    closeFeedbackBar = () => {
        this.props.storeCustomerPOOperationResponse("")
        this.setState({
            feedbackBarOpen: false
        })
    }

     componentDidMount() {
        this.props.fetchAllPurchaseOrders({ fromDate: this.getFromDate(), toDate: this.getToDate() });
        this.props.listAvailableLocations();
        this.props.getTableSetting(this.props.user.userId)
        this.props.listCustomers();
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.allPurchaseOrders !== this.props.allPurchaseOrders) {
            this.setState({
                ...prevState,
                ...this.props.allPurchaseOrders
            });
            //when all purchaseOrder is updated, it is likely because the toEdiPurchaseOrder is changed, update it
            if(this.state.toEditPurchaseOrder){

                this.props.allPurchaseOrders.map(purchaseOrder =>{
                    if(purchaseOrder.customerPurchaseOrderId === this.state.toEditPurchaseOrder.customerPurchaseOrderId){
                        //a purchase Order does not include a customer name, so add it here
                        let matchingPurchaseOrder = purchaseOrder
                        matchingPurchaseOrder.customerName = this.state.toEditPurchaseOrder?.customer?.[0]?.name
                        this.setState({
                            ...prevState,
                            toEditPurchaseOrder : matchingPurchaseOrder
                        })
                    }
                })
            }
        }
        if (!this.arrayEquals(prevProps.createdPurchaseOrderPreview, this.props.createdPurchaseOrderPreview)) {
            this.setState({
                pdfData: this.props.createdPurchaseOrderPreview
            })
        }
        if (!this.arrayEquals(prevProps.PDFpreviewReady, this.props.PDFpreviewReady)) {
            this.setState({
                pdfData: this.props.PDFpreviewReady
            })
        }
        if (prevProps.availableLocations !== this.props.availableLocations) {
            let findLocation = this.props.availableLocations.find((location) => location.shipAddressId === this.props.user.defaultLocationId)
            let defaultLocation = findLocation ? findLocation : {}
            this.setState({
                selectedLocation: defaultLocation,
                toLocation: defaultLocation
            })
        }
        if (prevProps.tableSetting !== this.props.tableSetting) {
            this.setState({ fromDate: this.getFromDate(), toDate: this.getToDate() });
        }

        if (prevState.selectedCustomer !== this.state.selectedCustomer || this.props.customers !== prevProps.customers) {
            if (this.state.selectedCustomer && this.props.customers){
                this.setState({
                    selectedCustomerInfo: this.props.customers.find((customer)=> customer.name === this.state.selectedCustomer)
                })
            }
        }

        // if the tax percentage is null then set previewable to false
        if (this.state.taxPercentage !== prevState.taxPercentage) {
            if (this.state.taxPercentage === "" || !this.state.taxPercentage) {
                this.setState({
                    previewable: false
                })
            }
        }

        if (this.state.createDate !== prevState.createDate) {

            if (this.state.createDate === "" || !this.state.createDate) {
                this.setState({
                    previewable: false
                })
            }
        }

        if (this.state.poNumber !== prevState.poNumber) {
            if (this.state.poNumber === "" || !this.state.poNumber) {
                this.setState({
                    previewable: false
                })
            }
        }

        if (this.props.customerPOOperationResponse !== prevProps.customerPOOperationResponse && this.props.customerPOOperationResponse != "") {
            this.setState({
                feedbackBarOpen: true,
                feedbackBarText:this.props.customerPOOperationResponse
            })
        }
    }

    getCustomerFromName(customerName) {
        let customer = null, s
        for (s in this.props.customers)
            if (this.props.customers[s].name === customerName) {
                customer = this.props.customers[s]
                break;
            }
        if (customer == null) {
            return null // no customer found
        }
        return customer
    }

    getToday = () => {
        var today = new Date()
        today = today.toString().split('GMT')[0] + "Z"
        return new Date(today)
    }

    getFromDate = () => {
        var date = this.getToday()
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setDate(date.getDate() - 14)
        return date;
    }

    getToDate = () => {
        var date = this.getToday()
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        return date;
    }

    setPage = (page) => {
        this.setState({
            page: page
        })
    }

    setRowsPerPage = (rowsPerPage) => {
        this.setState({
            rowsPerPage: rowsPerPage
        })
    }

    setRefetch = (fetched) => {
        this.setState({
            refetch: fetched
        })
    }


    handleDateChange = (date, key) => {
        this.setState({
            [key]: date
        })
    }

    applyDateFilters = (fromDate, toDate) => {
        this.props.fetchAllPurchaseOrders({
            fromDate,
            toDate
        })
    }

    arrayEquals(arr1, arr2) {
        if (!arr1 || !arr2) return false
        if (arr1.length !== arr2.length) return false
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) return false
        }
        return true
    }

    createPurchaseOrder = () => {
        this.setState({
            create: true,
            previewable: false,
            taxPercentage: this.state.selectedLocation.taxPercentage,
            toLocation: this.state.selectedLocation
        });
    }

    editPurchaseOrderQty = (purchaseOrder, fetchCreatedPurchaseOrderPreview) => {
        this.setState({
            editingPOqty: true,
            toEditPurchaseOrder: purchaseOrder,
            fetchCreatedPurchaseOrderPreview: fetchCreatedPurchaseOrderPreview
        });
    }

    handleCancel = () => {
        this.setState({
            create: false,
            entries: this.props.user.routes.includes('po-pricing') ? [{
                shortcode: '',
                partNum: '',
                description: '',
                discount: '0.00',
                price: '',
                quantity: 0,
                skid: 0,
                deleteEntry: true
            }] : [{
                shortcode: '',
                partNum: '',
                description: '',
                discount: '0.00',
                skid:0,
                quantity: 0,
                deleteEntry: true
            }],
            previewing: false,
            previewable: true,
            selectedCustomer: '',
            customerId: '',
            customerPurchaseOrderId: '',
            expectedDate: this.initDate(),
            notes: '',
            isHistorical: false,
            isSameAsBillingAddress: true,
            shipToAddress: {
                name: '',
                phone: '',
                country: '',
                addressLine1: '',
                addressLine2: '',
                postalCode: '',
                city:'',
                state: ''
            },
            samePreview: false,
            editingPOqty: false,
            editingPurchaseOrder: false,
            toEditPurchaseOrder: {},
            isDelete: false,
            isUndoDelete: false
        });
    }

    deleteInventoryReceived = (data) => {
        const fetchAlertsData = {
            selectedShipAddressId: this.props.user.locationIds,
            fetchUnshipped: false,
        }
        let currHour = new Date().getHours();
        if (currHour >= FETCH_UNSHIPPED_ALERTS_TIME) {
            fetchAlertsData.fetchUnshipped = true;
        } else {
            fetchAlertsData.fetchUnshipped = false;
        }
        this.props.deleteInventoryReceived(data, fetchAlertsData, this.updatePoStatus);
    }

    updatePoStatus = () => {
        let po = this.props.allPurchaseOrders.find((po) => po.poNumber === this.state.toEditPurchaseOrder.poNumber);
        this.setState({ toEditPurchaseOrder: po })
        this.showVoidIcon(po.status === "open");
        this.checkCompltedPo(po.status === "completed");
        this.checkCancelledPo(po.status === "cancelled");
    };

    updatePurchaseOrder = (data) => {
        const fetchAlertsData = {
            selectedShipAddressId: this.props.user.locationIds,
            fetchUnshipped: false,
        }
        let currHour = new Date().getHours();
        if (currHour >= FETCH_UNSHIPPED_ALERTS_TIME) {
            fetchAlertsData.fetchUnshipped = true;
        } else {
            fetchAlertsData.fetchUnshipped = false;
        }
        this.props.updatePurchaseOrder(data, fetchAlertsData, this.updatePoStatus);
    }
    changeHeader = (page) => {
        this.setState({
            header: page
        })
    }
    errorCheck = (date) => {
        let curEntries = this.state.entries;
        if (curEntries.length === 0)
            return false
        let good = true;
        let shortcodes = {};
        curEntries.forEach((entry) => {
            if (entry.shortcode in shortcodes) {
                good = false;
            } else {
                shortcodes[entry.shortcode] = 1
            }
            let quantity = parseFloat(entry.quantity)
            let price = parseFloat(entry.price)
            if (entry.shortcode === "" || quantity <= 0 || isNaN(quantity) || (this.props.user.routes.includes('po-pricing') && (price <= 0 || isNaN(price))))
                good = false;
        });
        if (this.state.editingPurchaseOrder) {
            for (const entry of curEntries) {
                for (const orderItem of this.state.toEditPurchaseOrder.orderItems) {
                    if (orderItem.shortcode === entry.shortcode) {
                        let receiveQty = parseInt(orderItem.quantityShipped)
                        let qty = parseInt(entry.quantity)
                        if (qty < receiveQty) {
                            good = false;
                        }
                    }
                }
            }
        }
        return good;
    }

    updateShipToAddress(name, value) {
        this.setState(prevState => ({
            shipToAddress: {
                ...prevState.shipToAddress,
                [name]: value
            }
        }));
    }

    // Functions for updating creatingPDF state
    updateField(name, value) {

        if(name === "expectedDate" ){
            const createDate = new Date(this.state.createDate)
            const expectedDate = new Date(value)

            const specificDate = new Date(createDate)
            specificDate.setDate(createDate.getDate() + 1)
            specificDate.setHours(0, 0, 0, 0)
            expectedDate.setHours(0, 0, 0, 0)

            const isPreviewable = expectedDate >= specificDate
            this.setPreviewable(isPreviewable)
            return this.setState({ [name]: value, samePreview: false, previewable: isPreviewable, pdfData: []})
        }
       let val = this.errorCheck(value)
       this.setState({ [name]: value, samePreview: false, previewable: val, pdfData: []})
    }

    async updateErrQuan(arr, index){
        arr.forEach((item) => {
            if(item.shortcode === this.state.toEditPurchaseOrder?.orderItems[index]?.shortcode){
                if(parseInt(item.quantity) < parseInt(this.state.toEditPurchaseOrder.orderItems[index].quantityShipped)){
                    const temp = { ...this.state.errEditQty };
                    temp[`${index}`] = false
                    this.setState({
                        errEditQty: temp,
                    })

                } else {
                    const temp = { ...this.state.errEditQty };
                    temp[`${index}`] = true
                    this.setState({
                        errEditQty: temp,
                    })
                }
            }
        })
    }

    showPdfErrorMessage = (isFailed) => {
        this.props.resetPdfPreviewData();
        this.setState({ pdfLoadSuccess: !isFailed })
    }

    previewPDF = () => {
        // only fetch a new pdf render if they have made changes to the order
        if (!this.state.samePreview) {
            const data = {
                entries: this.state.entries,
                customer: this.state.selectedCustomer,
                customerId: this.state.customerId,
                notes: this.state.notes,
                isSameAsBillingAddress: this.state.isSameAsBillingAddress,
                shipToAddress: this.state.shipToAddress,
                isHistorical: this.state.isHistorical,
                selectedLocation: this.state.toLocation,
                taxPercentage: this.state.taxPercentage,
                expectedDate: this.state.expectedDate,
                createDate: this.state.createDate,
                poNumber: this.state.poNumber
            };

            this.handleUpdatePurchaseOrderEmailTemplate()
            this.props.cachePDFpreview([])
            this.props.getPDFpreview(data, this.showPdfErrorMessage);
            this.setState({
                pdfData: this.props.PDFpreviewReady,
                previewing: true,
                samePreview: true
            });
        } else
        // use same data
        {
            this.props.cachePDFpreview(this.props.PDFpreviewReady);
            this.setState({
                previewing: true
            })
        }
    }

    handleUpdatePurchaseOrderEmailTemplate = () => {
        this.setState({
            purchaseOrderEmailTemplate: this.getCustomerFromName(this.state.selectedCustomer).purchaseOrderEmailTemplate
        })
    }

    handleSubmit = () => {
        if (this.state.submitting) return;
        const data = {
            entries: this.state.entries,
            customer: this.state.selectedCustomer,
            customerId: this.state.customerId,
            notes: this.state.notes,
            isSameAsBillingAddress: this.state.isSameAsBillingAddress,
            shipToAddress: this.state.shipToAddress,
            isHistorical: this.state.isHistorical,
            expectedDate: this.state.expectedDate,
            selectedLocation: this.state.toLocation,
            taxPercentage: this.state.taxPercentage,
            discountPercentage: this.state.discountPercentage,
            createDate: this.state.createDate,
            poNumber: this.state.poNumber,
        };
        this.setState({ submitting: true });
        this.props.createNewPurchaseOrder(data, () => window.location.reload());
    }

    handleEdit = () => {
        if (this.state.submitting) return;
        const data = {
            customerPurchaseOrderId: this.state.toEditPurchaseOrder.customerPurchaseOrderId,
            entries: this.state.entries,
            customer: this.state.selectedCustomer,
            customerId: this.state.customerId,
            notes: this.state.notes,
            isSameAsBillingAddress: this.state.isSameAsBillingAddress,
            shipToAddress: this.state.shipToAddress,
            isHistorical: this.state.isHistorical,
            expectedDate: this.state.expectedDate,
            selectedLocation: this.state.toLocation,
            taxPercentage: this.state.taxPercentage,
            discountPercentage: this.state.discountPercentage,
            createDate: this.state.createDate,
            poNumber: this.state.poNumber,
            save: true,
        }
        this.setState({ submitting: true });
        this.props.editPurchaseOrder(data, () => window.location.reload(), false, this.showPdfErrorMessage);
    }

    handleEditExpectedDeliveryDate = (customerPurchaseOrderId,createDate,expectedDeliveryDate,poNumber) =>{
        const data = {
            customerPurchaseOrderId: customerPurchaseOrderId,
            createDate: createDate,
            expectedDeliveryDate: expectedDeliveryDate,
            poNumber: poNumber,
        }
        this.props.updateExpectedDeliveryDate(data)
    }

    previewExistingPurchaseOrder = () => {
        if (!this.state.samePreview) {
            const data = {
                customerPurchaseOrderId: this.state.toEditPurchaseOrder.customerPurchaseOrderId,
                entries: this.state.entries,
                taxPercentage: this.state.taxPercentage,
                customer: this.state.selectedCustomer,
                customerId: this.state.customerId,
                notes: this.state.notes,
                isSameAsBillingAddress: this.state.isSameAsBillingAddress,
                shipToAddress: this.state.shipToAddress,
                isHistorical: this.state.isHistorical,
                expectedDate: this.state.expectedDate,
                createDate: this.state.createDate,
                poNumber: this.state.poNumber,
                selectedLocation: this.state.toLocation,
                save: false,
            }
            this.handleUpdatePurchaseOrderEmailTemplate()
            this.props.editPurchaseOrder(data, () => { }, true, this.showPdfErrorMessage);
            this.setState({
                pdfData: this.props.PDFpreviewReady,
                previewing: true,
                samePreview: true
            });
        } else
        // use same data
        {
            this.props.cachePDFpreview(this.props.PDFpreviewReady);
            this.setState({
                previewing: true
            })
        }

    }



    closeOrderConfirmationPreview = () => {
        this.setState({ previewingOrderConfirmation: false, previewOrderPONumber: "" })
    }

    handleOrderConfirmationPreview = () => {

        this.props.previewOrderConfirmationOrder({poNumber: this.state.toEditPurchaseOrder.poNumber})
        this.setState({
            previewingOrderConfirmation: true,
            previewOrderPONumber: this.state.toEditPurchaseOrder.poNumber
        })
    }


  downloadOrderConfirmationFile = () => {
        let blob = new Blob([Uint8Array.from(this.props.orderConfirmationPreview)], { type: "application/pdf" });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.state.previewOrderPONumber !== "" ? "Order Confirmation - " + this.state.previewOrderPONumber : "OrderConfirmation"
        link.click();
        // now clear it from memory
        window.URL.revokeObjectURL(link.href)
    };

    handlePreview = () => {
        this.props.fetchCreatedPurchaseOrderPreview(this.props.purchaseOrder.poNumber)
        this.setState({
            previewing: true
        })
    }

    handlePackingSlipOpen=(data)=>{
        this.setState({
            previewPackingSlip: true,
            sendPackingSlip: data
        })
    }
    handlePackingSlipClose=()=>{
        this.setState({
            previewPackingSlip: false,
            sendPackingSlip: null
        })
    }

    openPackingSlipPreview = (file, poNumber) => {
        this.setState({ previewingPS: true, previewingPsFile: file, previewingPsPoNum: poNumber, deletingPS: false })
    }


    closeCreatingPreview = () => {
        this.setState({ previewing: false, previewingPS: false, previewingPsFile: {}, previewingPsPoNum: 0, deletingPS: false, submitting: false })
    }

    closePreview = () => {
        this.setState({ previewing: false, pdfData: [] })
    }



    downloadFile = () => {
        let blob = new Blob([Uint8Array.from(this.props.createdPurchaseOrderPreview)], { type: "application/pdf" });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.state.previewingName !== "" ? this.state.previewingName : "PurchaseOrder"
        link.click();
        // now clear it from memory
        window.URL.revokeObjectURL(link.href)
    };

    handlePdfDataUpdate = (pdfData) => {
        this.setState({ pdfDataSlip: pdfData });
    }

    openEditPurchaseOrderPage = () => {
        this.setState({
            editingPurchaseOrder: true,
            poNumber: this.state.toEditPurchaseOrder.poNumber,
            isSameAsBillingAddress: this.state.toEditPurchaseOrder.isSameAsBillingAddress,
            shipToAddress: this.state.toEditPurchaseOrder.shipToAddress,
            isHistorical: this.state.toEditPurchaseOrder.isHistorical,
            selectedCustomer: this.state.toEditPurchaseOrder?.customer?.[0]?.name,
            taxPercentage: this.state.toEditPurchaseOrder.taxPercentage,
            discountPercentage: this.state.toEditPurchaseOrder.discountPercentage,
            entries: []
        })
    }

    handleEditPurchaseOrderPageCancel = () => {
        this.setState({
            editingPurchaseOrder: false,
            selectedCustomer: '',
            taxPercentage: '',
            discountPercentage: '0.00',
            editingPOqty: true
        })
    }

    cancelPurchaseOrder = () => {
        const data = {
            poNumber: this.state.toEditPurchaseOrder.poNumber
        }
        this.props.cancelPurchaseOrder(data, this.updatePoStatus)
        this.setState({ voidOpen: true, isDelete: false })
        if (this.props.status.success) {
            this.setState({ voidStatus: true })
        } else {
            this.setState({ voidStatus: false })
        }
    }


    handleFeedbackStatusOpen = () => {
        this.setState({
            feedbackOpen: true,
            feedback: true,
        })
    }
    handleFeedbackStatusClose = () => {
        this.setState({
            feedback: false,
            feedbackOpen: false
        })
    }
    handleVoidStatusClose = () => {
        this.setState({
            voidOpen: false,
            voidStatus: true
        })
    }

    handleUndoCancelledClose = () => {
        this.setState({
            undoCancelledFeedbackOpen: false,
            undoCancelStatus: true
        })
    }

    handleToLocationChange = (newLocation, updateTax) => {
        this.setState({
            toLocation: newLocation,
            taxPercentage: updateTax ? newLocation.taxPercentage ? newLocation.taxPercentage : "0" : this.state.taxPercentage
        })
        this.updateField("samePreview", false)
    }

    handleTaxPercentageChange = (newTax) => {
        if (!isNaN(newTax)) {
            this.setState({
                taxPercentage: newTax
            })
            this.updateField("samePreview", false)
        }
    }



    handleDiscountPercentageChange = (newDiscount) => {
        if (!isNaN(newDiscount)) {
            let newEntries = this.state.entries
            for (let i = 0; i < newEntries.length; i++) {
                newEntries[i].discount = newDiscount
            }
            this.setState({
                discountPercentage: newDiscount,
                entries: newEntries
            })
            this.updateField("samePreview", false)
        }
        if(newDiscount === ""){
            this.setState({ previewable: false });
        }
        else{
            this.setState({ previewable: true });
        }
    }

    setPreviewable = (option) => {
        this.setState({previewable:option})
    }

    toggleDeleteOption = () => {
        this.setState({
            isDelete: !this.state.isDelete
        })
    }

    toggleUndoDeleteOptions = () => {
        this.setState({
            isUndoDelete: !this.state.isUndoDelete
        })
    }

    handlePdfLoadSuccess = () => {
        this.setState({ pdfLoadSuccess: true })
    }

    handlePdfLoadError = () => {
        this.setState({ pdfLoadSuccess: false })
    }

    showVoidIcon = (canVoidPO) => {
        this.setState({ voiding: canVoidPO })
        this.setState({ canVoidPO: canVoidPO })
    }

    checkCancelledPo = (isCancelled) => {
        this.setState({ isCancelledPO: isCancelled })
    }


    checkCompltedPo = (isCompleted) => {
        this.setState({ isCompleted: isCompleted })
    }

    undoCancelled = () => {
        const data = {
            poNumber: this.state.toEditPurchaseOrder.poNumber
        }
        this.props.undoCancelPurchaseOrder(data, this.updatePoStatus)
        if (this.props.status.success) {
            this.setState({ undoCancelStatus: true, undoCancelledFeedbackOpen: true })
        } else {
            this.setState({ undoCancelStatus: false, undoCancelledFeedbackOpen: true })
        }
    }

    setZoom(zoom) {
        let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2)
        this.setState({
            scale: newScale
        })
    }

    handleSearchTextChange = (e) => {
        this.setState({
            searchText: e.target.value
        })
    }

    downloadSlipFile = () => {
        let blob = new Blob([Uint8Array.from(this.state.pdfDataSlip)], { type: "application/pdf" });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Packing Slip - ${this.state?.toEditPurchaseOrder?.poNumber}`
        link.click();
        // now clear it from memory
        window.URL.revokeObjectURL(link.href)
    };

    poSendCheck = () => {
        const templates = this.state.toEditPurchaseOrder?.customer?.[0]?.templates || [];
        const hasPurchaseOrderTemplate = templates.some(template => template.templateName === 'Packing Slip');
        return !(hasPurchaseOrderTemplate && this.state.pdfLoadSuccess);
    }

    poOrderConfirmationSendCheck = () => {
        const templates = this.state.toEditPurchaseOrder?.customer?.[0]?.templates || [];
        const hasOrderConfirmationTemplate = templates.some(template => template.templateName === 'Order Confirmation');
        return !(hasOrderConfirmationTemplate && this.props.orderConfirmationPreview);
    }

    sendPackingSlipToEmail = async () => {
        this.props.sendCustomerPurchaseOrderEmail(this.state.toEditPurchaseOrder?.customerId, this.state.sendPackingSlip, () => window.location.reload())
    }

    sendOrderConfirmationEmail = async () => {
        const data = { poNumber: this.state.toEditPurchaseOrder?.poNumber };
        this.props.sendCustomerOrderConfirmationEmail(
            this.state.toEditPurchaseOrder?.customerId,
            data,
            () => {
                // show snack bar
                this.setState({
                    feedbackBarOpen: true,
                    feedbackBarText: 'Email sent successfully',
                });

                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }
        );
    };

    sendEmail = async () => {
        const data = {
            purchaseOrderNumber: this.state.previewingName,
        };
        this.props.sendEmail_purchaseOrder(data, () => window.location.reload())
    }

    updateHasPurchaseOrderEmailTemplate = (purchaseOrderNumber) => {
        const data = {
            purchaseOrderNumber: purchaseOrderNumber,
        };
        this.props.fetchPurchaseOrderEmailTemplate(data)
        return false
    }

    deletePackingSlip = () => {
        this.props.deletePackingSlip({packingSlip: this.state.previewingPsFile, poNumber: this.state.previewingPsPoNum})
        this.closeCreatingPreview()
    }

    handlePreview = () => {
        this.state.fetchCreatedPurchaseOrderPreview(this.state.toEditPurchaseOrder.poNumber)
        this.setState({
            previewing: true
        })
    }

    generateCompleteCustomerInvoice = () => {
        this.props.generateCompleteCustomerInvoice(this.state.toEditPurchaseOrder.poNumber)
    }



    render() {
        let headerButtons
        if (this.state.editingPurchaseOrder) {
            if (this.state.previewing) {
                headerButtons = [
                    { icon: <KeyboardBackspaceIcon />, handler: this.closeCreatingPreview, title: "Back" },
                    { icon: <SaveIcon />, handler: this.handleEdit, title: "Save", disabled: !this.state.pdfLoadSuccess || this.state.submitting },
                    // { icon: <SendIcon />, handler: this.switchFromPreviewToEmail, title: "Save and Send", disabled: this.poSendCheck()},
                    { icon: <ZoomOutIcon />, handler: () => this.setZoom(-0.25), title: "Zoom Out", disabled: !this.state.pdfLoadSuccess },
                    { divider: <span style={{ padding: "5px", marginTop: "5px" }}>{this.state.scale * 100}%</span> },
                    { icon: <ZoomInIcon />, handler: () => this.setZoom(0.25), title: "Zoom In", disabled: !this.state.pdfLoadSuccess }
                ]
            }
            else {
                headerButtons = [{ icon: <KeyboardBackspaceIcon />, handler: this.handleEditPurchaseOrderPageCancel, title: "Back" },
                { icon: <VisibilityIcon />, handler: this.previewExistingPurchaseOrder, title: "Preview" }]
                if(!this.isPreviewEnabled()) headerButtons[1].disabled = true
            }
        } else if (this.state.editingPOqty) {
            if (this.state.previewing) {
                headerButtons = [
                    { icon: <KeyboardBackspaceIcon />, handler: this.closeCreatingPreview, title: "Back" },
                    { icon: <ZoomOutIcon />, handler: () => this.setZoom(-0.25), title: "Zoom Out", disabled: !this.state.pdfLoadSuccess },
                    { divider: <span style={{ padding: "5px", marginTop: "5px" }}>{this.state.scale * 100}%</span> },
                    { icon: <ZoomInIcon />, handler: () => this.setZoom(0.25), title: "Zoom In", disabled: !this.state.pdfLoadSuccess }
                ]
            }
             else if (this.state.previewingOrderConfirmation) {
                headerButtons = [
                    { icon: <KeyboardBackspaceIcon />, handler: this.closeOrderConfirmationPreview, title: "Back" },
                    { icon: <SendIcon />, handler: this.sendOrderConfirmationEmail, title: "Send", disabled: this.poOrderConfirmationSendCheck()},
                    { icon: <GetAppIcon />, handler: this.downloadOrderConfirmationFile, title: "Download", disabled: !this.props.orderConfirmationPreview },
                    { icon: <ZoomOutIcon />, handler: () => this.setZoom(-0.25), title: "Zoom Out", disabled: !this.state.pdfLoadSuccess },
                    { divider: <span style={{ padding: "5px", marginTop: "5px" }}>{this.state.scale * 100}%</span> },
                    { icon: <ZoomInIcon />, handler: () => this.setZoom(0.25), title: "Zoom In", disabled: !this.state.pdfLoadSuccess }
                ]
            }
            else if(this.state.previewPackingSlip) {
                headerButtons = [{ icon: <KeyboardBackspaceIcon />, handler: this.handlePackingSlipClose, title: "Back" },
                    { icon: <SendIcon />, handler: this.sendPackingSlipToEmail, title: "Save and Send", disabled: this.poSendCheck()},
                    { icon: <GetAppIcon />, handler: this.downloadSlipFile, title: "Download", disabled: !this.state.pdfLoadSuccess }]
                //download button
            }
            else if (this.state.previewingPS && !this.state.deletingPS) {
                headerButtons = [
                    { icon: <KeyboardBackspaceIcon />, handler: this.closeCreatingPreview, title: "Back" },
                    { icon: <ZoomOutIcon />, handler: () => this.setZoom(-0.25), title: "Zoom Out", disabled: !this.state.pdfLoadSuccess },
                    { divider: <span style={{ padding: "5px", marginTop: "5px" }}>{this.state.scale * 100}%</span> },
                    { icon: <ZoomInIcon />, handler: () => this.setZoom(0.25), title: "Zoom In", disabled: !this.state.pdfLoadSuccess },
                    { icon: <GetApp />, handler: () => this.handleDownloadRequest(), title: "Download PDF" },
                    { icon: <DeleteIcon />, handler: () => this.setState({deletingPS: true}), title: "Delete" },
                ]
            }
            else if (this.state.previewingPS && this.state.deletingPS) {
                headerButtons = [
                    { icon: <KeyboardBackspaceIcon />, handler: this.closeCreatingPreview, title: "Back" },
                    { icon: <ZoomOutIcon />, handler: () => this.setZoom(-0.25), title: "Zoom Out", disabled: !this.state.pdfLoadSuccess },
                    { divider: <span style={{ padding: "5px", marginTop: "5px" }}>{this.state.scale * 100}%</span> },
                    { icon: <ZoomInIcon />, handler: () => this.setZoom(0.25), title: "Zoom In", disabled: !this.state.pdfLoadSuccess },
                    { icon: <ClearIcon />, handler: () => this.setState({deletingPS: false}), title: "Cancel" },
                    { icon: <DeleteIcon />, handler: this.deletePackingSlip, title: "Confirm Delete" },
                ]
            }
            else {
                if (this.state.isDelete) {
                    headerButtons = [{ icon: <KeyboardBackspaceIcon />, handler: this.handleCancel, title: "Back" },
                    { icon: <DescriptionIcon/>, handler: this.handlePreview, title: "View Purchase Order" },
                    { icon: <EditIcon />, handler: this.openEditPurchaseOrderPage, title: "Edit Purchase Order" },
                    { divider: <span className="line-divider">|</span> },
                    { icon: <ClearIcon />, handler: this.toggleDeleteOption, title: "Cancel" },
                    { icon: <BlockIcon />, handler: this.cancelPurchaseOrder, title: "Cancel Purchase Order" },
                    ]
                } else {
                    if (this.state.isCompleted) {
                        headerButtons = [
                            { icon: <KeyboardBackspaceIcon />, handler: this.handleCancel, title: "Back" },
                            { icon: <DescriptionIcon/>, handler: this.handlePreview, title: "View Purchase Order" },
                            { icon: <EditIcon />, handler: this.openEditPurchaseOrderPage, title: "Edit Purchase Order" },
                            { icon: <AssignmentIcon />, handler: this.generateCompleteCustomerInvoice, title: "Generate Complete Invoice" },
                            { icon: <DescriptionIcon/>, handler: this.handleOrderConfirmationPreview, title: "View Order Confirmation" },
                        ]
                    }
                    else if (this.state.isCancelledPO) {
                        if (this.state.isUndoDelete) {
                            headerButtons = [{ icon: <KeyboardBackspaceIcon />, handler: this.handleCancel, title: "Back" },
                            { icon: <DescriptionIcon/>, handler: this.handlePreview, title: "View Purchase Order" },
                            { divider: <span className="line-divider">|</span> },
                            { icon: <ClearIcon />, handler: this.toggleUndoDeleteOptions, title: "Cancel" },
                            { icon: <UndoIcon />, handler: this.undoCancelled, title: "Undo Cancelled" },]
                        } else {
                            headerButtons = [{ icon: <KeyboardBackspaceIcon />, handler: this.handleCancel, title: "Back" },
                            { icon: <DescriptionIcon/>, handler: this.handlePreview, title: "View Purchase Order" },
                            { icon: <UndoIcon />, handler: this.toggleUndoDeleteOptions, title: "Undo Cancelled" },]
                        }
                    }
                    else if (!this.state.canVoidPO) {
                        headerButtons = [
                            { icon: <KeyboardBackspaceIcon />, handler:  ()=>{this.handleCancel()}, title: "Back" },
                            { icon: <DescriptionIcon/>, handler: this.handlePreview, title: "View Purchase Order" },
                            { icon: <EditIcon />, handler: this.openEditPurchaseOrderPage, title: "Edit Purchase Order" },
                            { icon: <AssignmentIcon />, handler: this.generateCompleteCustomerInvoice, title: "Generate Complete Invoice" },
                            { icon: <DescriptionIcon/>, handler: this.handleOrderConfirmationPreview, title: "View Order Confirmation" },

                        ]
                    } else {
                        headerButtons = [
                            { icon: <KeyboardBackspaceIcon />, handler: this.handleCancel, title: "Back" },
                            { icon: <DescriptionIcon/>, handler: this.handlePreview, title: "View Purchase Order" },
                            { icon: <EditIcon />, handler: this.openEditPurchaseOrderPage, title: "Edit Purchase Order" },
                            { icon: <BlockIcon />, handler: this.toggleDeleteOption, title: "Cancel Purchase Order" },
                            { icon: <AssignmentIcon />, handler: this.generateCompleteCustomerInvoice, title: "Generate Complete Invoice" },
                            { icon: <DescriptionIcon/>, handler: this.handleOrderConfirmationPreview, title: "View Order Confirmation" },
                        ]
                    }
                }
            }
        } else if (this.state.create) {
            if (this.state.previewing) {
                headerButtons = [{ icon: <KeyboardBackspaceIcon />, handler: this.closeCreatingPreview, title: "Back" },
                { icon: <SaveIcon />, handler: this.handleSubmit, title: "Save", disabled: !this.state.pdfLoadSuccess || this.state.submitting },
               // { icon: <SendIcon />, handler: this.switchFromPreviewToEmail, title: "Save and Send", disabled: (!this.state.pdfLoadSuccess || !this.state.purchaseOrderEmailTemplate)},
                { icon: <ZoomOutIcon />, handler: () => this.setZoom(-0.25), title: "Zoom Out", disabled: !this.state.pdfLoadSuccess },
                { divider: <span style={{ padding: "5px", marginTop: "5px" }}>{this.state.scale * 100}%</span> },
                { icon: <ZoomInIcon />, handler: () => this.setZoom(0.25), title: "Zoom In", disabled: !this.state.pdfLoadSuccess }]
            } else {
                headerButtons = [{ icon: <KeyboardBackspaceIcon />, handler: this.handleCancel, title: "Cancel" },
                { icon: <VisibilityIcon />, handler: this.previewPDF, title: "Preview" }]
                if(!this.isPreviewEnabled()) headerButtons[1].disabled = true
            }
        } else {
            if (this.state.previewing) {
                headerButtons = [{ icon: <KeyboardBackspaceIcon />, handler: this.closePreview, title: "Back" },
                { icon: <GetAppIcon />, handler: this.downloadFile, title: "Download", disabled: !this.state.pdfLoadSuccess },
                // { icon: <SendIcon />, handler: this.sendEmail, title: "Send", disabled: (!this.state.pdfLoadSuccess || !this.props.hasPurchaseOrderEmailTemplate)},
                { icon: <ZoomOutIcon />, handler: () => this.setZoom(-0.25), title: "Zoom Out", disabled: !this.state.pdfLoadSuccess },
                { divider: <span style={{ padding: "5px", marginTop: "5px" }}>{this.state.scale * 100}%</span> },
                { icon: <ZoomInIcon />, handler: () => this.setZoom(0.25), title: "Zoom In", disabled: !this.state.pdfLoadSuccess }]
                if (this.props.createdPurchaseOrderPreview.length === 0) headerButtons[1].disabled = true
            }
            else {
                headerButtons = [{
                    icon: <AddCircleIcon />,
                    handler: this.createPurchaseOrder,
                    title: CREATE_PURCHASE_ORDER
                }]
            }
        }
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ErrorFeedbackBar />
                <Paper className="paper">
                    <FeedbackBar
                        open={this.state.feedbackBarOpen}
                        severity={this.state.error ? ERROR : SUCCESS}
                        message={this.state.feedbackBarText}
                        handleClose={this.closeFeedbackBar}
                    />
                    <FeedbackBar
                        open={this.state.feedbackOpen}
                        handleClose={this.handleFeedbackStatusClose}
                        severity={this.state.feedback ? SUCCESS : ERROR}
                        message={this.state.feedback ? 'Invoice generated' : ''}
                    />
                    <FeedbackBar
                        open={this.state.voidOpen}
                        handleClose={this.handleVoidStatusClose}
                        severity={this.state.voidStatus ? SUCCESS : ERROR}
                        message={this.state.voidStatus ? 'PO Cancel Success' : 'PO Cancel Failed'}
                    />
                    <FeedbackBar
                        open={this.state.undoCancelledFeedbackOpen}
                        handleClose={this.handleUndoCancelledClose}
                        severity={this.state.undoCancelStatus ? SUCCESS : ERROR}
                        message={this.state.undoCancelStatus ? 'PO Undo Cancelled Success' : 'PO Undo Cancelled Failed'}
                    />
                    {/*<FeedbackBar*/}
                    {/*    open={!this.state.pdfLoadSuccess}*/}
                    {/*    handleClose={this.handlePdfLoadSuccess}*/}
                    {/*    severity={ERROR}*/}
                    {/*    message={"Failed to Load PDF"}*/}
                    {/*/>*/}
                    <CustomToolbar
                        title={ this.state.create || this.state.editingPurchaseOrder || this.state.previewing || this.state.editingPOqty ? "Customer Order" : PURCHASE_ORDER}
                        createTitle={CREATE_PURCHASE_ORDER}
                        backTitle={CREATE_PURCHASE_ORDER}
                        onClick={this.createPurchaseOrder}
                        handleClose={this.handleCancel}
                        creatingOrder={this.state.create}
                        headerButtons={headerButtons}
                    />
                    {this.state.editingPurchaseOrder &&
                        <EditCustomerPurchaseOrders
                            updatePurchaseOrder={this.updatePurchaseOrder}
                            handleCancel={this.handleCancel}
                            changeHeader={this.changeHeader}
                            updateShipToAddress={(name, value) => this.updateShipToAddress(name, value)}
                            updateField={(name, value) => this.updateField(name, value)}
                            updateErrQuan={(arr, index) => this.updateErrQuan(arr, index)}
                            pdfData={this.state.pdfData}
                            previewing={this.state.previewing}
                            entries={this.state.entries}
                            selectedCustomer={this.state.selectedCustomer}
                            customerPurchaseOrderId={this.state.customerPurchaseOrderId}
                            customerId={this.state.customerId}
                            samePreview={this.state.samePreview}
                            expectedDate={this.state.expectedDate}
                            purchaseOrder={this.state.toEditPurchaseOrder}
                            editingPurchaseOrder={true}
                            selectedLocation={this.state.toLocation}
                            taxPercentage={this.state.taxPercentage}
                            handleTaxChange={this.handleTaxPercentageChange}
                            handleDiscountChange={this.handleDiscountPercentageChange}
                            locations={this.props.availableLocations}
                            handleLocationChange={this.handleToLocationChange}
                            customers={this.props.customers}
                            handlePdfLoadSuccess={this.handlePdfLoadSuccess}
                            handlePdfLoadError={this.handlePdfLoadError}
                            pdfLoadSuccess={this.state.pdfLoadSuccess}
                            notes={this.state.notes}
                            scale={this.state.scale}
                            errEditQty={this.state.errEditQty}
                            hasPricingRole={this.props.user.routes.includes('customer-po-pricing')}
                            setPreviewable={this.setPreviewable}
                            previewable={this.state.previewable}
                            discountPercentage={this.state.discountPercentage}
                            selectedCustomerInfo={this.state.selectedCustomerInfo}
                            isHistorical={this.state.isHistorical}
                            isSameAsBillingAddress={this.state.isSameAsBillingAddress}
                            shipToAddress={this.state.shipToAddress}
                            createDate={this.state.createDate}
                            poNumber={this.state.poNumber}
                        /> ||
                        this.state.editingPOqty &&
                        <PurchaseCustomerOrderDetails
                            handleFeedbackStatusOpen={this.handleFeedbackStatusOpen}
                            createCustomerInvoice={this.props.createCustomerInvoice}
                            onPdfDataUpdate={this.handlePdfDataUpdate}
                            previewPackingSlip={this.state.previewPackingSlip}
                            updatePurchaseOrder={this.updatePurchaseOrder}
                            deleteInventoryReceived={this.deleteInventoryReceived}
                            previewing={this.state.previewing}
                            previewingOrderConfirmation={this.state.previewingOrderConfirmation}
                            orderConfirmationPreview={this.props.orderConfirmationPreview}
                            handleEditExpectedDeliveryDate={this.handleEditExpectedDeliveryDate}
                            pdfData={this.props.createdPurchaseOrderPreview}
                            previewCreatedPurchaseOrder={this.props.previewCreatedPurchaseOrder}
                            purchaseOrder={this.state.toEditPurchaseOrder}
                            fetchCreatedPurchaseOrderPreview={this.state.fetchCreatedPurchaseOrderPreview}
                            allPurchaseOrders={this.props.allPurchaseOrders}
                            handlePdfLoadSuccess={this.handlePdfLoadSuccess}
                            handlePdfLoadError={this.handlePdfLoadError}
                            pdfLoadSuccess={this.state.pdfLoadSuccess}
                            canVoidPO={this.showVoidIcon}
                            checkCancelledPo={this.checkCancelledPo}
                            checkCompletedPo={this.checkCompltedPo}
                            previewPackingSlipFile={this.props.previewPackingSlipFile}
                            openPackingSlipPreview={this.openPackingSlipPreview}
                            previewingPS={this.state.previewingPS}
                            handlePackingSlipOpen={this.handlePackingSlipOpen}
                            handlePackingSlipClose={this.handlePackingSlipClose}
                            scale={this.state.scale}
                            user={this.props.user}
                            triggerDownload={this.state.triggerDownload}
                            onDownload={() => this.setState({ triggerDownload: false })}
                        /> ||
                        this.state.create &&
                        <CreateCustomerPurchaseOrder
                            emailTemplates={this.props.emailTemplates}
                            handleCancel={this.handleCancel}
                            changeHeader={this.changeHeader}
                            updateShipToAddress={(name, value) => this.updateShipToAddress(name, value)}
                            updateField={(name, value) => this.updateField(name, value)}
                            pdfData={this.state.pdfData}
                            previewing={this.state.previewing}
                            entries={this.state.entries}
                            selectedCustomer={this.state.selectedCustomer}
                            customerPurchaseOrderId={this.state.customerPurchaseOrderId}
                            customerId={this.state.customerId}
                            samePreview={this.state.samePreview}
                            expectedDate={this.state.expectedDate}
                            selectedLocation={this.state.toLocation}
                            taxPercentage={this.state.taxPercentage}
                            handleTaxChange={this.handleTaxPercentageChange}
                            isSameAsBillingAddress={this.state.isSameAsBillingAddress}
                            shipToAddress={this.state.shipToAddress}
                            isHistorical={this.state.isHistorical}
                            createDate={this.state.createDate}
                            poNumber={this.state.poNumber}
                            discountPercentage={this.state.discountPercentage}
                            handleDiscountChange={this.handleDiscountPercentageChange}
                            locations={this.props.availableLocations}
                            handleLocationChange={this.handleToLocationChange}
                            handlePdfLoadSuccess={this.handlePdfLoadSuccess}
                            handlePdfLoadError={this.handlePdfLoadError}
                            pdfLoadSuccess={this.state.pdfLoadSuccess}
                            notes={this.state.notes}
                            scale={this.state.scale}
                            hasPricingRole={this.props.user.routes.includes('customer-po-pricing')}
                            selectedCustomerInfo={this.state.selectedCustomerInfo}
                        />
                        ||
                        <PurchaseCustomerOrdersTable
                            updatePurchaseOrder={this.updatePurchaseOrder}
                            deleteInventoryReceived={this.deleteInventoryReceived}
                            //changeHeader={this.changeHeader}
                            rows={this.props.allPurchaseOrders}
                            previewing={this.state.previewing}
                            updateShipToAddress={(name, value) => this.updateShipToAddress(name, value)}
                            updateField={(name, value) => this.updateField(name, value)}
                            pdfData={this.props.createdPurchaseOrderPreview}
                            previewCreatedPurchaseOrder={this.props.previewCreatedPurchaseOrder}
                            updateHasPurchaseOrderEmailTemplate={this.updateHasPurchaseOrderEmailTemplate}
                            storeCreatedPurchaseOrderPreview={this.props.storeCreatedPurchaseOrderPreview}
                            editingPO={this.state.editingPOqty}
                            handleEditPo={this.editPurchaseOrderQty}
                            page={this.state.page}
                            setPage={this.setPage}
                            rowsPerPage={this.state.rowsPerPage}
                            setRowsPerPage={this.setRowsPerPage}
                            handleDateChange={this.handleDateChange}
                            handlePdfLoadSuccess={this.handlePdfLoadSuccess}
                            handlePdfLoadError={this.handlePdfLoadError}
                            pdfLoadSuccess={this.state.pdfLoadSuccess}
                            saveTableSetting={this.props.saveTableSetting}
                            userInfo={this.props.user}
                            tableSetting={this.props.tableSetting}
                            scale={this.state.scale}
                            searchText={this.state.searchText}
                            handleSearchTextChange={this.handleSearchTextChange}
                            fromDate={this.state.fromDate}
                            toDate={this.state.toDate}
                            applyDateFilters={this.applyDateFilters}
                            fetchAllPurchaseOrders={this.props.fetchAllPurchaseOrders}
                            selectedCustomerInfo={this.state.selectedCustomerInfo}
                            deleteOrder={this.props.deleteCustomerOrder}
                            customers={this.props.customers ? this.props.customers.map(s => s.name) : []}
                            setRefetch={this.setRefetch}
                            refetch={this.state.refetch}
                        />
                    }
                </Paper>
            </MuiPickersUtilsProvider>
        )
    }
}

const mapStateToProps = (state) => ({
    PDFpreviewReady: PDFpreviewReadySelector(state),
    allPurchaseOrders: allPurchaseOrdersSelector(state),
    newPurchaseOrders: newPurchaseOrdersSelector(state),
    partialPurchaseOrders: partialPurchaseOrdersSelector(state),
    completedPurchaseOrders: completedPurchaseOrdersSelector(state),
    createdPurchaseOrderPreview: createdPurchaseOrderPreviewSelector(state),
    user: userInfoSelector(state),
    status: statusSelector(state),
    availableLocations: availableLocationsSelector(state),
    customers:customersSelector(state),
    tableSetting: tableSettingSelector(state),
    emailTemplates: emailTemplatesSelector(state),
    hasPurchaseOrderEmailTemplate: hasPurchaseOrderEmailTemplateSelector(state),
    customerPOOperationResponse: customerPOOperationResponseSelector(state),
    orderConfirmationPreview: orderConfirmationPreviewSelector(state),
});

const actionCreators = {
    fetchAllPurchaseOrders,
    updatePurchaseOrder,
    deleteInventoryReceived,
    createNewPurchaseOrder,
    createSendNewPurchaseOrder,
    getPDFpreview,
    cachePDFpreview,
    previewPackingSlipFile,
    previewCreatedPurchaseOrder,
    storeCreatedPurchaseOrderPreview,
    deletePackingSlip,
    cancelPurchaseOrder,
    listCustomers,
    listAvailableLocations,
    editPurchaseOrder,
    undoCancelPurchaseOrder,
    resetPdfPreviewData,
    saveTableSetting,
    getTableSetting,
    sendCustomerPurchaseOrderEmail,
    sendCustomerOrderConfirmationEmail,
    fetchPurchaseOrderEmailTemplate,
    sendEmail_purchaseOrder,
    updateExpectedDeliveryDate,
    createCustomerInvoice,
    deleteCustomerOrder,
    generateCompleteCustomerInvoice,
    storeCustomerPOOperationResponse,
    previewOrderConfirmationOrder
}

PurchaseCustomerOrders.propTypes = {
    allPurchaseOrders: PropTypes.array,
    newPurchaseOrders: PropTypes.array,
    partialPurchaseOrders: PropTypes.array,
    completedPurchaseOrders: PropTypes.array,
    availableLocations: PropTypes.array,
}

PurchaseCustomerOrders.defaultProps = {
    allPurchaseOrders: [],
    newPurchaseOrders: [],
    partialPurchaseOrders: [],
    completedPurchaseOrders: [],
    availableLocations: []
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, PurchaseCustomerOrders);